var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("my_page.form_title")) + " ")]), _c('div', {
    staticClass: "page__desc",
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('my_page.form_desc'))
    }
  }), _vm.getModuleConfig('my_page.content') ? _c('div', {
    staticClass: "page__content",
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('my_page.content'))
    }
  }) : _vm._e(), _c('div', [_vm.showLoading ? _c('Loading', {
    attrs: {
      "loading-message": "載入中..."
    }
  }) : !_vm.showLoading && _vm.coupons.length > 0 ? _vm._l(_vm.coupons, function (coupon) {
    return _c('coupon-card', {
      key: coupon.id,
      attrs: {
        "coupon": coupon,
        "show-code": false,
        "button-text": coupon.button_text
      },
      on: {
        "exchange": function exchange($event) {
          return _vm.goToDetail(coupon);
        }
      }
    });
  }) : _c('coupon-empty')], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }